<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">id</th>
                <th class="text-left">abbréviation</th>
                <th class="text-left">Bailleur</th>
                <th class="text-left">Activité</th>
                <th class="text-left">Thème</th>
                <th class="text-left">Description</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in Activites" :key="index">
                <td>{{ item.id }}</td>
                <td>{{ item.abbr_parcours }}</td>
                <td>{{ item.ll_bailleur }}</td>
                <td>{{ item.ll_parcours }}</td>
                <td>{{ item.ll_theme }}</td>
                <td>{{ item.description_parcours }}</td>
                <td>
                  <v-btn
                    @click="listeEtapesActivites(item)"
                    x-small
                    color="primary"
                    rounded
                    dark
                  >
                    Etapes
                  </v-btn>

                  <v-btn
                    x-small
                    color="green"
                    @click="goToStats(item)"
                    rounded
                    dark
                  >
                    Formations
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogActivite: false,
      idActivite: null,
      abbr_parcours: "",
      description_parcours: "",
      ll_parcours: "",
      theme_selected: "",
      dialogDeleteActivite: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  created() {
    if (!this.$route.params.projet) {
      console.log("pas de paramètres", this.$route.params.projet);

      this.$router.go(-1);
    }
    this.GetActivites();
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetActivites: "Activites/GetAll",
    }),
    goToStats(item) {
      this.$router.push({
        path: "/superviseur/stats/statsFormationsProjets",
        query: item,
      });
    },
    listeEtapesActivites(activite) {
      this.$router.push({
        name: "superviseur-rapports-etapes-id",
        params: { activite },
      });
    },
    listeCampagneActivites(activite) {
      console.log(activite);
    },
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      Themes: (state) => state.Themes.Themes,
      Activites(state) {
        return _.filter(state.Activites.Activites, {
          programmes_id_programme: this.$route.params.projet.id,
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
